export const stableFund = {
    code: 'FNBSF',
    expectedReturn: 0.07,
    term: 3,
    scenarios: {
        3: { down: 0.0053525950816317, expected: 0.00769438687962458, up: 0.0114446093980377 },
        4: { down: 0.00541016966380263, expected: 0.00848084084278048, up: 0.0110232253010657 },
    },
};
